import React from 'react';

import { flagStyles } from '../settings';

const SvgTZ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5424px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTZ;
